import { useState, useEffect } from 'react';
import type { GLSelectOptions } from '@group-link-one/gl-components';
import type { Page } from '../Types/Pages.types';
import { getPages } from '../Services/Pages.service';

interface UseTenantPagesOptions {
  tenantSlug: string;
  isMain?: boolean;
}

export const useTenantPages = ({ tenantSlug, isMain }: UseTenantPagesOptions) => {
  const [pages, setPages] = useState<Page[]>([]);
  const [pageOptions, setPageOptions] = useState<GLSelectOptions[]>([]);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    if (!tenantSlug) {
      setPages([]);
      setPageOptions([]);
      return;
    }

    let cancelled = false;

    const fetchPages = async () => {
      setIsLoading(true);
      try {
        const response = await getPages({
          tenantSlug,
          limit: 100,
          ...(isMain !== undefined && { isMain }),
        });
        if (!cancelled) {
          setPages(response.data);
          setPageOptions(
            response.data.map((page, index) => ({
              id: String(index),
              text: page.name,
              value: page.id,
            })),
          );
        }
      } catch {
        if (!cancelled) {
          setPages([]);
          setPageOptions([]);
        }
      } finally {
        if (!cancelled) setIsLoading(false);
      }
    };

    fetchPages();

    return () => {
      cancelled = true;
    };
  }, [tenantSlug, isMain]);

  return { pages, pageOptions, isLoading };
};
